const imagesPrefix =
  "https://raw.githubusercontent.com/creativetimofficial/public-assets/master/material-design-system/presentation/pages";

export default function getPagesData(messages) {
  return [
    {
      image: `${imagesPrefix}/about-us.jpg`,
      name: messages.pages.items[0].name,
      route: messages.pages.items[0].route,
    },
    {
      image: `${imagesPrefix}/contact.jpg`,
      name: messages.pages.items[1].name,
      route: messages.pages.items[1].route,
    },
    {
      image: `${imagesPrefix}/author.jpg`,
      name: messages.pages.items[2].name,
      route: messages.pages.items[2].route,
    },
    {
      image: `${imagesPrefix}/contact.jpg`,
      name: messages.pages.items[3].name,
      route: messages.pages.items[3].route,
    },
  ];
}
